import { lazy } from 'react';

import { FEATURES } from './services/config';
interface Route {
  path: string;
  element: any;
  wrapper?: 'AutoHeight' | 'AutoHeightNoOffset' | '';
  exact?: boolean;
}

// Core DEX: swap, classic pools, liquidity and the exchange account.
const coreRoutes: Route[] = [
  {
    path: '/account',
    element: lazy(
      () => import(/* webpackChunkName: "account" */ 'src/pages/AccountPage')
    ),
  },
  {
    path: '/pools/manage/:kind/:poolId',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "clmmManage" */ 'src/pages/pools/ClmmManagePage'
        )
    ),
    wrapper: 'AutoHeight',
    exact: true,
  },
  {
    path: '/pools/add-v3',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "addPoolV3" */ 'src/pages/pools/AddV3PoolPage'
        )
    ),
    wrapper: 'AutoHeight',
    exact: true,
  },
  {
    path: '/pools/add-v4',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "addPoolV4" */ 'src/pages/pools/AddV4PoolPage'
        )
    ),
    wrapper: 'AutoHeight',
    exact: true,
  },
  {
    path: '/pools/add',
    element: lazy(
      () =>
        import(/* webpackChunkName: "addPool" */ 'src/pages/pools/AddPoolPage')
    ),
    wrapper: 'AutoHeight',
    exact: true,
  },
  {
    path: '/pools/add-token',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "addToken" */ 'src/pages/pools/AddTokenPage'
        )
    ),
    wrapper: 'AutoHeight',
  },
  {
    path: '/pools',
    exact: true,
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "pools" */ 'src/pages/pools/LiquidityPage/LiquidityPage'
        )
    ),
    wrapper: 'AutoHeight',
  },
  {
    path: '/pool/:id',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "poolDetail" */ 'src/pages/pools/DetailsPage'
        )
    ),
    wrapper: 'AutoHeight',
  },
  {
    path: '/yourliquidity',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "yourliquidity" */ 'src/pages/poolsV3/YourLiquidityPageV3'
        )
    ),
    wrapper: 'AutoHeight',
  },
];

// Concentrated-liquidity (DCL) pools. Needs REACT_APP_DCL_CONTRACT_ID.
const dclRoutes: Route[] = [
  {
    path: '/poolV2/:id',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "poolV2Detail" */ 'src/pages/poolsV3/PoolDetailV3'
        )
    ),
    wrapper: 'AutoHeight',
  },
  {
    path: '/yoursLiquidityDetailV2/:id/:status?',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "yoursLiquidityDetailV2Detail" */ 'src/pages/poolsV3/YourLiquidityDetailV3'
        )
    ),
    wrapper: 'AutoHeight',
  },
  {
    path: '/addLiquidityV2',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "addLiquidityV2" */ 'src/pages/poolsV3/AddYourLiquidityPageV3'
        )
    ),
    wrapper: 'AutoHeight',
  },
];

// Farming. Needs REACT_APP_FARM_CONTRACT_ID / REACT_APP_BOOST_FARM_CONTRACT_ID.
const farmRoutes: Route[] = [
  {
    path: '/v2farms/:id?',
    element: lazy(
      () =>
        import(
          /* webpackChunkName: "v2farmsDetail" */ 'src/pages/farms/FarmsBoostPage'
        )
    ),
    wrapper: 'AutoHeight',
  },
  {
    path: '/farms',
    element: lazy(
      () => import(/* webpackChunkName: "farms" */ 'src/pages/farms/FarmsPage')
    ),
    wrapper: 'AutoHeight',
  },
];

const swapPage = lazy(
  () => import(/* webpackChunkName: "swap" */ 'src/pages/SwapPage')
);

const routes: Route[] = [
  ...coreRoutes,
  ...(FEATURES.dcl ? dclRoutes : []),
  ...(FEATURES.boostFarms ? farmRoutes : []),
  { path: '/swap', element: swapPage, wrapper: 'AutoHeight' },
  // Must stay last: '/' matches every path.
  { path: '/', element: swapPage, wrapper: 'AutoHeight' },
];

export default routes;
